{
  "ATTRIBUTES_MGMT": {
    "HEADER": "Pielāgotas Īpašības",
    "HEADER_BTN_TXT": "Pievienot Pielāgotu Īpašību",
    "LOADING": "Notiek pielāgotu īpašību iegūšana",
    "DESCRIPTION": "Pielāgots atribūts ļauj izsekot papildu informāciju par jūsu kontaktpersonām vai sarunām, piemēram, abonēšanas plānu vai viņu pirmā pirkuma datumu. Varat pievienot dažāda veida pielāgotus atribūtus, piemēram, tekstu, sarakstus vai skaitļus, lai tvertu konkrētu jums nepieciešamo informāciju.",
    "LEARN_MORE": "Uzzināt vairāk par pielāgotajiem atribūtiem",
    "COUNT": "{n} attribute | {n} attributes",
    "SEARCH_PLACEHOLDER": "Meklēt īpašības...",
    "NO_RESULTS": "No attributes found matching your search",
    "ATTRIBUTE_MODELS": {
      "CONVERSATION": "Saruna",
      "CONTACT": "Kontaktpersona",
      "COMPANY": "Uzņēmums"
    },
    "ATTRIBUTE_TYPES": {
      "TEXT": "Teksts",
      "NUMBER": "Numurs",
      "LINK": "Saite",
      "DATE": "Date",
      "LIST": "Saraksts",
      "CHECKBOX": "Izvēles rūtiņa"
    },
    "ADD": {
      "TITLE": "Pievienot Pielāgotu Īpašību",
      "SUBMIT": "Izveidot",
      "CANCEL_BUTTON_TEXT": "Atcelt",
      "FORM": {
        "NAME": {
          "LABEL": "Parādāmais Nosaukums",
          "PLACEHOLDER": "Ievadiet pielāgotās īpašības parādāmo nosaukumu",
          "ERROR": "Nepieciešams nosaukums"
        },
        "DESC": {
          "LABEL": "Apraksts",
          "PLACEHOLDER": "Ievadiet pielāgotās īpašības aprakstu",
          "ERROR": "Nepieciešams apraksts"
        },
        "MODEL": {
          "LABEL": "Attiecas uz",
          "PLACEHOLDER": "Lūdzu, izvēlieties vienu",
          "ERROR": "Nepieciešams modelis"
        },
        "TYPE": {
          "LABEL": "Tips",
          "PLACEHOLDER": "Lūdzu, izvēlieties tipu",
          "ERROR": "Nepieciešams tips",
          "LIST": {
            "LABEL": "Parādīt Vērtības",
            "PLACEHOLDER": "Lūdzu, ievadiet vērtību un nospiediet taustiņu enter",
            "ERROR": "Jābūt vismaz vienai vērtībai"
          }
        },
        "KEY": {
          "LABEL": "Atslēga",
          "PLACEHOLDER": "Ievadiet pielāgotas īpašības atslēgu",
          "ERROR": "Nepieciešama atslēga",
          "IN_VALID": "Nederīga atslēga"
        },
        "REGEX_PATTERN": {
          "LABEL": "Regex Šablons",
          "PLACEHOLDER": "Lūdzu, ievadiet pielāgotu atribūtu regex šablonu. (Neobligāti)"
        },
        "REGEX_CUE": {
          "LABEL": "Regex Norādījums",
          "PLACEHOLDER": "Lūdzu, ievadiet regex šablona norādījumu. (Neobligāti)"
        },
        "ENABLE_REGEX": {
          "LABEL": "Iespējot regex pārbaudi"
        },
        "BADGES": {
          "PRE_CHAT": "Pre-chat",
          "RESOLUTION": "Resolution"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Pielāgotā īpašība ir veiksmīgi pievienota!",
        "ERROR_MESSAGE": "Nevarēja izveidot Pielāgotu Atribūtu. Lūdzu, vēlāk pamēģiniet vēlreiz."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Dzēst",
      "API": {
        "SUCCESS_MESSAGE": "Pielāgotā Īpašība ir veiksmīgi izdzēsta.",
        "ERROR_MESSAGE": "Nevarēja izdzēst pielāgoto īpašību. Mēģiniet vēlreiz."
      },
      "CONFIRM": {
        "TITLE": "Vai esat pārliecināts, ka vēlaties izdzēst - {attributeName}",
        "PLACE_HOLDER": "Lai apstiprinātu, lūdzu, uzrakstiet {attributeName}",
        "MESSAGE": "Dzēšana noņems pielāgoto īpašību",
        "YES": "Dzēst ",
        "NO": "Atcelt"
      }
    },
    "EDIT": {
      "TITLE": "Rediģēt Pielāgoto Īpašību",
      "UPDATE_BUTTON_TEXT": "Atjaunināt",
      "TYPE": {
        "LIST": {
          "LABEL": "Parādīt Vērtības",
          "PLACEHOLDER": "Lūdzu, ievadiet vērtības un nospiediet taustiņu enter"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Pielāgotā Īpašība ir veiksmīgi atjaunināta",
        "ERROR_MESSAGE": "Atjauninot pielāgoto īpašību, radās kļūda. Lūdzu, mēģiniet vēlreiz"
      }
    },
    "TABS": {
      "HEADER": "Pielāgotās Īpašības",
      "CONVERSATION": "Saruna",
      "CONTACT": "Kontaktpersona",
      "COMPANY": "Uzņēmums"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Nosaukums",
        "DESCRIPTION": "Apraksts",
        "TYPE": "Tips",
        "KEY": "Atslēga"
      },
      "BUTTONS": {
        "EDIT": "Rediģēt",
        "DELETE": "Dzēst"
      },
      "EMPTY_RESULT": {
        "404": "Nav izveidotas pielāgotas īpašības",
        "NOT_FOUND": "Nav nokonfigurētas pielāgotas īpašības"
      },
      "REGEX_PATTERN": {
        "LABEL": "Regex Šablons",
        "PLACEHOLDER": "Lūdzu, ievadiet pielāgotu atribūtu regex šablonu. (Neobligāti)"
      },
      "REGEX_CUE": {
        "LABEL": "Regex Norādījums",
        "PLACEHOLDER": "Lūdzu, ievadiet regex šablona norādījumu. (Neobligāti)"
      },
      "ENABLE_REGEX": {
        "LABEL": "Iespējot regex pārbaudi"
      }
    },
    "BADGES": {
      "PRE_CHAT": "Pre-chat",
      "RESOLUTION": "Resolution"
    }
  }
}
